import {
  ImageDisplayQuality,
  getClosestImageUrl,
} from 'approot/shared/images/imgix-responsive';
import { ResponsiveImage } from 'approot/shared/images/imgix-responsive.constants';

export function getPrintImage(
  imageUrls: ResponsiveImage[] | null,
  previewSize?: number
) {
  if (!imageUrls?.length) return '';

  return getClosestImageUrl({
    containerSize: previewSize ? previewSize : 2000,
    quality: ImageDisplayQuality.Low,
    imageUrls,
  });
}
